class Helper {
  //   static downloadWindow;

  static setWindow(winName) {
    this.downloadWindow = winName;
  }

  static getWindow() {
    return this.downloadWindow;
  }

  static postTransformRequest(data, headers) {
    var str = [];
    for (var p in data)
      if (data.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(data[p]));
      }
    return str.join("&");
  }

  static fetchSiteConfig() {
    var matchedContents = window.location.hostname.match(/(.*)\.((.*)\.(.*))/);
    return {
      origin: window.location.origin,
      siteName: matchedContents && matchedContents[1],
      protocol: window.location.protocol.substring(0, window.location.protocol.length - 1),
      domain: matchedContents && matchedContents[2]
    }
  }

  static is_iPad() {
    return !!navigator.userAgent.match(/iPad/);
  }

  static is_iPhone() {
    return !!navigator.userAgent.match(/iPhone/);
  }

  static newWindowNotSupported() {
    // #CHKOUTENGG-791 : Issue occurs in both Android & Iphone 
    return (navigator.userAgent.match(/FB/i) || navigator.userAgent.match(/Instagram/i) || navigator.userAgent.match(/GSA/i));
  }

  static downloadUrl(url) {
    if (this.is_iPad() || this.is_iPhone()) {
      if (this.downloadWindow) {
        this.downloadWindow.location.href = url;
      }
    } else {
      var iframe = document.createElement('iframe');
      iframe.style.display = "none";
      iframe.src = url;
      document.body.appendChild(iframe);
    }
  }

  static isAndroidInstagram() {
    return !!navigator.userAgent.match(/Android/) && !!(navigator.userAgent.match(/FB/) || navigator.userAgent.match(/Instagram/i))
  }

}


export default Helper


// WEBPACK FOOTER //
// ./src/utils/url-helper.js